import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputOtpComponent } from './input-otp/input-otp.component';



@NgModule({
  declarations: [
    InputOtpComponent
  ],
  exports: [
    InputOtpComponent
  ],
  imports: [
    CommonModule
  ]
})
export class InputOtpModule { }
